// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import CollaspedOutlineSvg from '@rsuite/icon-font/lib/action/CollaspedOutline';
var CollaspedOutline = createSvgIcon({
  as: CollaspedOutlineSvg,
  ariaLabel: 'collasped outline',
  category: 'action',
  displayName: 'CollaspedOutline'
});
export default CollaspedOutline;